<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <label for="">{{ $t('Delivery to') }}: <span class="required">*</span></label>
          <div class="alert  rounded border-danger border border-dashed" role="alert" v-if="modal">
          <p class="color-danger"> {{ $t("Delivery is not available at your location") }} !</p>
        </div>
        <div class="input-group mb-3">
          <gmap-autocomplete
            class="form-control form-control-solid"
            placeholder="Search location"
            @place_changed="setPlace"
          ></gmap-autocomplete>
         
        </div>

         <div class="btn btn-default shadow-sm" @click="currentLocation()" style="position: absolute;    z-index: 1;    background: #ffffff;    margin: 8px;"> 
            {{ $t('Current location')}}
            <base-icon icon_name="disc" class="pointer ml-2" />
        </div> 

        <gmap-map
          @click="mark"
          :center="center"
          :zoom="17"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false,
          }"
          style="width: 100%; height: 400px"
        >
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="{ url: icon }"
            @click="center = m.position"
          ></gmap-marker>
        </gmap-map>
      </div>
      <img
        src="@/assets/loading.svg"
        width="50"
        v-if="delivery_fee_loading"
        alt=""
      />
    </div> 
    <div class="mt-3">
      <ValidationObserver ref="form">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          name="NameReciever"
        >
          <div class="form-group">
            <label>{{ $t("Name Receiver") }}: <span class="required">*</span></label>
            <input
              v-model="model.receiver_name"
              type="text"
              class="form-control form-control-solid"
              :placeholder="$t('Name Receiver')"
            />
            <span class="error" v-if="errors[0]">
              {{ $t('Receiver is required')}}
            </span>
          </div>
        </validation-provider>
        
        <validation-provider
          v-slot="{ errors }"
          rules="required|numeric"
          name="phoneNumber"
        >
          <div class="form-group">
            <label>{{ $t("Phone Number") }}: <span class="required">*</span></label>
            <input
              v-model="model.customer_phone_number"
              type="text"
              class="form-control form-control-solid"
              :placeholder="$t('Enter phone number')"
            />
            <span class="error" v-if="errors[0]">
              {{ $t('Invalid phone number')}}
            </span>
          </div>
        </validation-provider>
      </ValidationObserver>
    </div> 
  </div>
</template>

<style lang="css">
  .required{
    color: red;
  }
  .vue-map-container .vue-map {
    border-radius: 10px;
  }
  .vue-map-container {
    border: 1px solid #c0cac4;
    border-radius: 10px;
  }
</style>

<script>
import Vue from "vue";
import store from "@/store";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: "places", // necessary for places input
  },
});
export default {
  name: "BaseDeliveryMap",
  data: () => {
    return {
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      icon: require("@/assets/pin.png"),
      currentPlace: null,
      modal: false,
      model: {
        customer_phone_number: null,
        receiver_name: null,
      },
      is_available: false,
    };
  },
  computed: {
    orderInfo() {
      return store.getters["order/order_info"];
    },
    state_order() {
      return store.getters["order/state_order"];
    },
    btn_state() {
      return store.getters["location_selected/btnState"];
    },
    placeSelected() {
      return store.getters["location_selected/placeSelected"];
    },
    order() {
      return store.getters["order/pending_order"];
    },
    delivery_fee() {
      return store.getters["order/delivery_fee"];
    },
    delivery_fee_loading() {
      return store.getters["order/loading_delivery_fee"];
    },
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
    user() {
      return store.getters["auth/user"];
    },
  },
  mounted() {
    if (this.order.lat && this.order.lng) {
     
      this.selectedMap();
    } else {
      this.geolocate();
    }

    if(this.user){
      this.model.customer_phone_number = this.user.phone
      this.model.receiver_name = this.user.contact_fullname
    }

    // this.model.customer_phone_number = this.orderInfo.customer_phone_number;
    // this.model.receiver_name = this.orderInfo.receiver_name;
  },
  watch: {
    model: {
      handler(value) {
        this.submitData();
      },
      deep: true,
    },
  },
  methods: {
    mark(event) {
      const marker = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.markers = [];
      this.places = [];
      this.markers.push({ position: marker });
      this.places.push(this.currentPlace);
      this.center = marker;
      this.currentPlace = null;
      this.checkLocationAvailable();
    },
    setPlace(place) {
      this.markers = [];
      this.places = [];
      this.currentPlace = place;
      this.addMarker();
    },
    currentLocation() { 
       this.geolocate(); 
    },
    addMarker() {
      if (this.currentPlace) {
          const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
        this.checkLocationAvailable();
      }
    },
    selectedMap() {
      
       var lat = this.order.lat
       var lng =this.order.lng
      navigator.geolocation.getCurrentPosition(
        (position) => {
      
          const marker = {
            lat: lat,
            lng: lng,
          };

          this.markers = [];
          this.places = [];
          this.markers.push({ position: marker });
          this.places.push(this.currentPlace);
          this.center = marker;
          this.currentPlace = null;
          this.checkLocationAvailable();
        },
        (error) => {}
      );
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const marker = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.markers = [];
          this.places = [];
          this.markers.push({ position: marker });
          this.places.push(this.currentPlace);
          this.center = marker;
          this.currentPlace = null;
          this.checkLocationAvailable();
        },
        (error) => {}
      );
    },
    async checkLocationAvailable() {
      this.order.lat = this.center.lat;
      this.order.lng = this.center.lng;
      this.model.lat = this.center.lat;
      this.model.lng = this.center.lng;
      this.$store.dispatch("order/setOrderInfo", this.model);
      await store.dispatch("order/CalcDeliveryFee", this.order);
      if (this.delivery_fee.available !== true) {
        this.modal = true;
        this.$emit("valid", false);
        return;
      }

      this.modal = false;
      this.is_available = true;
      this.submitData();
    },

    async submitData() {
      await this.$store.dispatch("order/setOrderInfo", this.model);
      const isValid = await this.$refs.form.validate();
      if (isValid === true && this.is_available === true) {
        this.$emit("valid", true);
      } else {
        this.$emit("valid", false);
      }
    },
  },
};
</script>